import { useState, useEffect } from "react";
import { ReactComponent as LogoBackground } from "../../images/logo.svg";
import BioContent from "../../data/bio.json";

function Bio() {
  const [bio, setBio] = useState<string[]>([]);

  useEffect(() => {
    setBio(BioContent);
  }, []);

  return (
    <div className="bg-gray-100">
      <div className="w-full h-48 2xl:h-52 bg-gray-800 transform -skew-y-6"></div>
      <div className="-mt-32 bg-gradient-to-t from-gray-900 to-gray-800 transform lg:-mt-48 2xl:-mt-52 overflow-hidden">
        <div className="container grid grid-cols-1 mx-auto lg:auto-rows-auto lg:py-8">
          <div className="col-start-1 row-start-1 self-end justify-self-end w-3/4 translate-x-6 lg:col-start-1 lg:row-start-1 lg:col-span-1 lg:w-[58%] lg:p-0 lg:translate-x-16 xl:w-[50%] xl:translate-x-12 2xl:w-[44%] 2xl:translate-x-8">
            <LogoBackground className="block fill-current stroke-current text-petrol-400 opacity-[0.15] lg:mx-auto lg:opacity-30" />
          </div>
          <div className="col-start-1 row-start-1 self-center lg:pb-1 lg:pl-1 lg:col-start-1 lg:col-span-1 lg:row-start-1">
            <div className="p-2 lg:p-4 lg:w-2/3 xl:w-3/5 xl:ml-32 2xl:w-1/2 2xl:ml-64">
              <h1 className="font-Forum relative text-4xl text-gray-200 lg:text-5xl 2xl:text-5xl mb-6">
                Meine berufliche Geschichte
              </h1>
              <ol className="relative">
                {bio.map((entry, index) => {
                  const match = entry.match(/^\[(\d{4})\]: (.+)$/);
                  const year = match ? match[1] : "";
                  const text = match ? match[2] : entry;
                  const isFirst = index === 0;
                  const isLast = index === bio.length - 1;
                  return (
                    <li key={index} className="relative pb-7 last:pb-0">
                      {bio.length > 1 && (
                        <div
                          className={[
                            "absolute left-[5px] w-0.5 bg-petrol-600",
                            isFirst ? "top-[8px]" : "top-0",
                            isLast ? "h-[8px]" : "bottom-0",
                          ].join(" ")}
                        />
                      )}
                      <div className="flex items-start gap-4">
                        <div className="flex-none z-10 w-3 h-3 rounded-full bg-petrol-400 ring-2 ring-petrol-700 mt-[2px]" />
                        <div>
                          <span className="block text-petrol-300 text-xs font-bold tracking-widest uppercase leading-4 mb-0.5">
                            {year}
                          </span>
                          <span className="text-gray-200 text-base 2xl:text-lg leading-snug">
                            {text}
                          </span>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bio;
